module.exports = __webpack_public_path__ + "media/newstyle/images/play_circle-9d6985828b10522332fd4b0d7c300248.svg";